'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  terms: {
    empty: 'Aucun item.',
    new: 'Ajouter un item',
    next: 'Page suivante',
    previous: 'Page précédente',
    form: {
      confirmSave: 'Voulez-vous enregistrer les modifications \xE0 cet \xE9l\xE9ment\xA0?',
      dontSave: 'Ne pas enregistrer',
      name: 'Nom',
      save: 'Enregistrer'
    }
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/locales/fr/terms.js
// module id = 2297
// module chunks = 0